
const DayDreamsList = [
    {
        name: "3D-render",
        description: "A simple 3D-renderer written in pure JS.",
        date: new Date(2018, 11, 10)
    },
    {
        name: "ASCII-art",
        description: "Converts images to ASCII characters.",
        date: new Date(2019, 9, 30)
    },
    {
        name: "double-pendulum",
        description:  "Simulates 2 pendulums connected to each other.",
        date: new Date(2019, 0, 7)
    },
    {
        name: "GameOfLife",
        description: "A random starting of Game of Life as described by John Conway.",
        date: new Date(2018, 9, 13)
    },
    {
        name: "hallowjump",
        description: "A simple chrome dino like game built for TIC-80.",
        date: new Date(2018, 9, 26)
    },
    {
        name: "jumpergame",
        description: "A simple chrome dino like game with neural networks (sorta).",
        date: new Date(2018, 3, 18)
    },
    {
        name: "minesweeper",
        description: "The classic minesweeper game (currenlty mildly broken).",
        date: new Date(2019, 2, 28)
    },
    {
        name: "particles",
        description: "Cool particles moving around.",
        date: new Date(2019, 7, 12)
    },
    {
        name: "perlin-noise",
        description: "Terrain Generation using OpenSimplex noise.",
        date: new Date(2020, 4, 3)
    },
    {
        name: "RSA",
        description: "Work with RSA encryption yourself. (might be broken idk)",
        date: new Date(2019, 0, 26)
    },
    {
        name: "snake",
        description: "The classic Snake game.",
        date: new Date(2018, 6, 7)
    },
    {
        name: "speakerbel",
        description: "Place speakers and see how much sound they produce.",
        date: new Date(2019, 5, 11)
    }
]

export default DayDreamsList